import createSvgIcon from '../Utils/CreateSvgIcon';

export const Building = createSvgIcon(
  <path
    fillRule="evenodd"
    d="M3 21V6Q3 4 5 4H19Q21 4 21 6V21H3ZM7.5 7.5H10V10H7.5V7.5ZM14 7.5H16.5V10H14V7.5ZM7.5 12H10V14.5H7.5V12ZM14 12H16.5V14.5H14V12ZM10.5 17H13.5V21H10.5V17Z"
  />,
  'Building',
);
